import {store} from "../store";
import langFileEs from '/source/lang_files/lang.es.json';
import langFileEn from '/source/lang_files/lang.en.json';

export default function langSwitch({ next, to }) {
    let langChoice = to.query.lang;
    let returnPath = to.query.origpath;
    if (returnPath === null) {
        returnPath = '/';
    }

    if (langChoice === null) {
        return next(returnPath);
    }

    window.$cookies.set('langChoice', langChoice, '365d', null, null, true, 'None');


    store.state.langChoice = langChoice;

    if (langChoice === 'en') {
        store.state.langFile = langFileEn;
    } else if (langChoice === 'es') {
        store.state.langFile = langFileEs;
    } else {
        store.state.langFile = langFileEn;
    }


    return next(to.query.origpath);

}
